import { IoWarningOutline } from "react-icons/io5";

const RemoveMember = ({ member, onDelete, onClose }) => {
  return (
    <div className="p-8">
      <div className="flex justify-center">
        <div>
          <div className="flex justify-center">
            <IoWarningOutline className="text-red-500 text-5xl" />
          </div>
          <p className="text-gray-400 text-sm mt-7">
            Are you sure you want to remove{" "}
            <span className="text-gray-500">{member.name}</span>?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-3 mt-12 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button outline-none float-right hover:text-blue-400"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            className="button bg-red-500 text-white"
            onClick={() => onDelete(member)}
          >
            Yes, delete it.
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveMember;
